import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { CONFIG } from "../../common/constant/constant";
import { logout } from "../slice/user.slice";

export const alertsApi = createApi({
   reducerPath: "alert-api",
   baseQuery: fetchBaseQuery({
      baseUrl: CONFIG.ADMIN_API_URL,
      // the session is an HttpOnly cookie set by the server, so no token is read or sent from here
      credentials: "include",
   }),
   endpoints: (builder) => ({
      alertsData: builder.mutation({
         query: (payload) => ({
            url: "settings/alerts/errorList",
            method: "get",
            body: payload,
         }),
         transformResponse: (result) => result,
         async onQueryStarted(args, { dispatch, queryFulfilled }) {
            try {
               await queryFulfilled;
            } catch (error) {
               if (error?.error?.status === 401) {
                  setTimeout(() => {
                     dispatch(logout());
                  }, 2000);
               }
            }
         },
      }),
   }),
});

export const { useAlertsDataMutation } = alertsApi;
